module.exports = __webpack_public_path__ + "img/list1.9ab8c7ec.png";